import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.styl']
})
export class SectionComponent implements OnInit {

  public screenSize: number = 0;

  constructor() {
  }

  ngOnInit() {
    this.screenSize = window.innerHeight;
    console.log(this.screenSize);
  }
}



// WEBPACK FOOTER //
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/section/section.component.ts